"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropOption = exports.deadlineExceeded = exports.reachedUpperLimit = exports.convertItemValueIntoInputValue = void 0;
var isAfter_1 = __importDefault(require("date-fns/isAfter"));
var convertItemValueIntoInputValue = function (value) {
    return (value != null && "".concat(value)) || '';
};
exports.convertItemValueIntoInputValue = convertItemValueIntoInputValue;
var reachedUpperLimit = function (item) {
    if (item.remain == null) {
        return false;
    }
    return item.remain <= 0;
};
exports.reachedUpperLimit = reachedUpperLimit;
var deadlineExceeded = function (item, currentTime) {
    if (currentTime == null) {
        return false;
    }
    if (item.registrationDeadline == null) {
        return false;
    }
    return (0, isAfter_1.default)(new Date(currentTime), new Date(item.registrationDeadline));
};
exports.deadlineExceeded = deadlineExceeded;
var dropReachedUpperLimitOption = function (item, hideUpperLimitReachedOption) {
    if (item.isAnswered) {
        return false;
    }
    if (item.remain == null) {
        return false;
    }
    return hideUpperLimitReachedOption && item.remain <= 0;
};
var dropDeadlineExceededOption = function (item, hideDeadlineExceededOption, currentTime) {
    if (item.isAnswered) {
        return false;
    }
    if (!hideDeadlineExceededOption) {
        return false;
    }
    return (0, exports.deadlineExceeded)(item, currentTime);
};
var dropOption = function (item, hideUpperLimitReachedOption, hideDeadlineExceededOption, currentTime) {
    return (dropReachedUpperLimitOption(item, hideUpperLimitReachedOption) ||
        dropDeadlineExceededOption(item, hideDeadlineExceededOption, currentTime));
};
exports.dropOption = dropOption;
